module.exports = __webpack_public_path__ + "img/icon1.77b21c5c.svg";